import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Side-effect: installs a fetch interceptor that sends cookies + redirects
// to /api/auth/google/start on 401. Must run before any component fires
// off its initial requests.
import './client/authFetch';
import './globals.css';

// Keep application menus working while suppressing the browser's native menu.
const suppressContextMenu = (event: MouseEvent) => event.preventDefault();
document.addEventListener('contextmenu', suppressContextMenu, true);
if (import.meta.hot) import.meta.hot.dispose(() => document.removeEventListener('contextmenu', suppressContextMenu, true));

const container = document.getElementById('root');
if (!container) throw new Error('#root element not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
